import { Tag } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import { Spinner } from '@/components/ui/spinner';

interface SubmitButtonProps {
  onClick: () => void;
  disabled: boolean;
  isSaving: boolean;
  isViewMode: boolean;
}

export function SubmitButton({ onClick, disabled, isSaving, isViewMode }: SubmitButtonProps) {
  const { t } = useTranslation();

  if (isViewMode) return null;

  return (
    <Button
      type="submit"
      onClick={onClick}
      disabled={disabled}
      className="h-10 px-8 bg-blue-600 hover:bg-blue-700 text-white shadow-sm transition-all active:scale-95">
      {isSaving ? (
        <Spinner className="mr-2 h-4 w-4 border-white/30 border-t-white" />
      ) : (
        <Tag className="mr-2 h-4 w-4" />
      )}
      {t('contacts.saveContact', 'Save Contact')}
    </Button>
  );
}
